import React, { Component } from 'react';
import { get } from 'lodash';

class Crumb extends Component {
  constructor(props) {
    super(props);

    this.id = get(this.props.group, 'id', null);
    this.name = get(
      this.props.group,
      'name',
      t('groups.system_generated.title'),
    );
  }

  handleClick = () => {
    this.props.updateActiveGroup(this.id);

    if (this.id === null) {
      this.props.updateMyOrganization(true);
    }
  };

  render() {
    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/anchor-is-valid
      <a className="c-brand-blue c-p" onClick={this.handleClick}>
        {this.name}
      </a>
    );
  }
}

export default Crumb;
